<template>
  <div>
    <TopBar title="Notifications"/>
    <div class="page-content bottom-content">
      <div class="container">
        <SingleNotification/>
        <SingleNotification/>
        <SingleNotification/>
        <SingleNotification/>
      </div>
    </div>


  </div>
</template>

<script setup>
import {onMounted} from "vue";
import TopBar from "@/views/master/layouts/partials/TopBar";
import SingleNotification from "@/components/singleNotification";


onMounted(() => {

})
</script>

<style scoped>


</style>